for (var i = 0; i < stores.length; i++) {
  if (!stores[i]) continue;
  var storeName = stores[i].name.toLowerCase();
  var storeId = stores[i].storeID;

  if (specialProduct === true) {
    if (storeId === 7200) {
      delete stores[i];
    }
  }

  if (specialProduct2 === true) {
    if (storeId === 5954) {
      delete stores[i];
    }
  }

  if (specialProduct3 === true) {
    if (storeId === 4054) {
      delete stores[i];
    }
  }

   if (specialProduct4 === true) {
    if (storeId === 8780) {
      delete stores[i];
    }
  }

  if (specialProduct5 === true) {
    if (storeId === 4699) {
      delete stores[i];
    }
  }

  if (specialProduct6 === true) {
    if (storeId === 5258) {
      delete stores[i];
    }
  }
}
/* var shippingClicked = false;
document.addEventListener("crStorePickupInit", function (e) {
  storePickup.changePickupButtonText(); // removes the hide class and visually displays it
});
document.addEventListener("crPickupActivated", function (e) {
  storePickup.setPickupButtonValues();

  // console.log("____ activated _____");
  disableCheckoutButton2();
  var tt = setInterval(function () {
    if (shippingClicked === false) disableCheckoutButton2();
  }, 1000);
  setTimeout(function () {
    clearInterval(tt);
  }, 5000);

  jqCR(
    "#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number"
  ).on("mouseout keyup change", function () {
    //console.log('check for others and activate checkout')
    checkPickupFields();
  });

  jqCR(".cr-shipping-method").on("click", function () {
    shippingClicked = true;
    // console.log("Activate");
    activateCheckoutButton2();
    var tt = setInterval(function () {
      activateCheckoutButton2();
    }, 1000);
    setTimeout(function () {
      clearInterval(tt);
    }, 2000);
  });
});

function checkPickupFields() {
  var pickupDate = jqCR("#pickup-date-start").val();
  var firstName = jqCR("#pickup-first-name").val();
  var lastName = jqCR("#pickup-last-name").val();
  var phone = jqCR("#pickup-number").val();
  var selectedStoreId = jqCR("#pickup-selected-store-id").val();
  if (selectedStoreId && firstName && lastName && phone) {
    activateCheckoutButton2();
  } else {
    disableCheckoutButton2();
  }
}

function activateCheckoutButton2() {
  document.querySelector("#checkout").disabled = false;
}

function disableCheckoutButton2() {
  // console.log("disable");
  document.querySelector("#checkout").disabled = true;
} */

document.addEventListener('crStorePickupInit', function (e) {
  setTimeout(function(){
    console.log('buttons loaded', jqCR('.cr-radio'))
    jqCR('.cr-radio').on('click', function(e){
      console.log('aaaaaaaa')
      e.stopPropagation();
      var currentValue = '#' + $(this).val();
      console.log(currentValue)
      jqCR(currentValue).click()
      
      setTimeout(function(){jqCR(currentValue).click()}, 50)
  
    })    
  }, 500)
  
})



// continuosly check if the fields are completed
document.addEventListener('crPickupActivated', function (e) { 
    console.log('____ activated _____');
  
    disableCheckoutButton2();
    var tt = setInterval(function(){
      disableCheckoutButton2();
      //console.log('check.............')
      var fieldsCorrect = checkPickupFields();
      //console.log({fieldsCorrect})
      if (fieldsCorrect === true) {
        //clearInterval(tt);  
      }
      
    }, 1000);
    //setTimeout(function() { clearInterval(tt); }, 5000);  

  jqCR('#pickup-date-start, #note-pickup-date, #pickup-first-name, #pickup-last-name, #pickup-number').on('mouseout keyup change', function(){
  	//console.log('check for others and activate checkout')  	
    checkPickupFields()
  })
  
  jqCR(document).on('change', '#pickup-selected-store', function(){checkPickupFields()})  
  trackChange(jqCR("#pickup-selected-store")[0] );  

   //jqCR(document).on('change', '#note-pickup-date', function(){checkPickupFields()})  
   //trackChange(jqCR("#note-pickup-date")[0] );
});


MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var trackChange = function(element) {
  var observer = new MutationObserver(function(mutations, observer) {
    if(mutations[0].attributeName == "value") {
        jqCR(element).trigger("change");
    }
  });
  observer.observe(element, {
    attributes: true
  });
}

function checkPickupFields(){
  	//var pickupDate = jqCR('#pickup-date-start').val();
    var firstName = jqCR('#pickup-first-name').val();
    var lastName = jqCR('#pickup-last-name').val();
    var phone = jqCR('#pickup-number').val();
    var selectedStoreId = jqCR('#pickup-selected-store-id').val()
    if (selectedStoreId && firstName && lastName && phone) {
      activateCheckoutButton2();
      return true;
    }
    disableCheckoutButton2()
    return false;
}

function activateCheckoutButton2(){
  //console.log('Activate')
      document.querySelector('#checkout').disabled = false;
  }

function disableCheckoutButton2(){    
    document.querySelector('#checkout').disabled = true;
}
